'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('calculatorCtrl',['$scope', '$http', '$log', function ($scope, $http, $log) {
	$scope.postUrl = calculatorData.postUrl;
	$scope.country = '';
	$scope.type = '';
	$scope.riskNumber = '';
	$scope.amt = '';
	$scope.countries = calculatorData.countries;
	$scope.types = calculatorData.types;
	$scope.limits = calculatorData.limits;
	$scope.gal = $scope.limits.gal;

	$scope.setCountriesSelected = function () {
		for (var j = 0; j < $scope.countries.length; j++) {
			if ($scope.country == $scope.countries[j].id) {
				$scope.countries.selected = $scope.countries[j];
				$scope.riskNumber = $scope.countries.selected.risk;
			}
		}
	};

	$scope.range = function (min, max, step) {
		step = step || 1;
		var input = [];
		for (var i = min; i <= max; i += step) {
			input.push(i);
		}
		return input;
	};

	$scope.setGuarantee = function () {
		if (typeof ($scope.gal) === 'undefined' || $scope.gal > $scope.limits.gal || $scope.gal < 1) {
			$scope.gal = $scope.limits.gal;
		}
	};

	$scope.countRisk = function () {
		if ($scope.postUrl !== '') {
			$scope.loading = true;
			$http({
				method: 'POST',
				url: $scope.postUrl,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name,
				data: {
					type: $scope.type,
					riskNumber: $scope.riskNumber,
					amt: $scope.amt,
					gal: $scope.gal,
				},
			}).then(function (response) {
				$scope.loading = false;
				if (response.data.success) {
					$scope.displayRisk(response.data, 'politicalRisk', '#prGroup');
					$scope.displayRisk(response.data, 'commercialRisk', '#crGroup');
					$scope.displayRisk(response.data, 'politicalAndCommercialRisk', '#pacrGroup');
				} else if (angular.isDefined(response.data.messages)) {
				}
				if (angular.isDefined(response.data.debug)) {
					$log.debug(response.data.debug);
				}
			}, function (response) {
				console.log(['Error', response]);
			});
		}
	};

$scope.displayRisk = function (response, $riskType, $groupId) {
    if (response.hasOwnProperty($riskType)) {
        $('#' + $riskType).text(response[$riskType]); // Set the text content
        $scope.showResults = true;
        $($groupId).removeClass('d-none');
    } else {
        if (!$($groupId).hasClass("d-none")) {
            $scope.showResults = true;
            $($groupId).addClass("d-none");
        }
    }
};
}]);